 <template>
    <div
        :style="$_getStyle"
        class="menu-detail shadowSmall"
        :class="getObjectDetailClass"
    >
        <!-- Header -->
        <div class="panel-header modeless">
            <h3 class="panel-header-title crop modeless">
                {{ $t('labelMenu') }}
            </h3>
            <!-- Close icon -->
            <icon-close
                id="panel-menu-close"
                @close="togglePanel({ panelName: 'menu', visible: false })"
                iconColor=""
                class="d-inline-block float-right"
            >
            </icon-close>
        </div>
        <div class="menucontainer">
            <!-- Legend -->
            <div
                v-if="showLegendMenuOption"
                class="sidebar-item"
                @click="
                    togglePanel({ panelName: INTERFACE_PANEL_TRIGGERS.LEGEND })
                "
            >
                <em class="legend-icon"></em>
                <span class="menu-span-adjustment">{{
                    $t('labelLegend')
                }}</span>
            </div>
            <!-- Filters -->
            <div
                v-if="showFilterMenuOption"
                class="sidebar-item"
                @click="
                    togglePanel({ panelName: INTERFACE_PANEL_TRIGGERS.FILTERS })
                "
            >
                <em class="filter-icon"></em>
                <span class="menu-span-adjustment">{{
                    $t('labelFilters')
                }}</span>
            </div>
            <!-- Measure -->
            <div
                v-if="showMeasureMenuOption"
                class="sidebar-item"
                @click="
                    togglePanel({
                        panelName: INTERFACE_PANEL_TRIGGERS.MEASURE_EDIT
                    })
                "
            >
                <em class="measure-icon"></em>
                <span class="menu-span-adjustment">{{
                    $t('labelCreateMeasure')
                }}</span>
            </div>
            <!-- Show welcome message -->
            <div
                v-if="showWelcomeMessageOption"
                class="sidebar-item"
                @click="$_click_welcome_panel()"
            >
                <em class="welcome-icon"></em>
                <span class="menu-span-adjustment">{{
                    $t('menuItemWelcomeMessage')
                }}</span>
            </div>
            <!-- Print -->
            <div
                v-if="showPrintMenuOption"
                class="sidebar-item"
                @click="
                    togglePanel({ panelName: INTERFACE_PANEL_TRIGGERS.PRINT })
                "
            >
                <em class="print-icon"></em>
                <span class="menu-span-adjustment">{{ $t('labelPrint') }}</span>
            </div>
            <!-- Accessibility -->
            <b-link
                v-if="showAccessibilityMenuOption && getWebThemeParameters.tma"
                :to="{
                    name: 'accessibleInfo',
                    params: {
                        tma:
                            getWebThemeParameters.guid ||
                            getWebThemeParameters.tma
                    }
                }"
                class="menu-link"
            >
                <div class="sidebar-item">
                    <em class="accessibility-icon"></em>
                    <span class="menu-span-adjustment">{{
                        $t('accessibility.AccessibilityView')
                    }}</span>
                </div>
            </b-link>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import {
        INTERFACE_PANEL_TRIGGERS,
        MENUBAR_HEIGHT
    } from '../../../../constants';
    import IconClose from '../../../IconClose.vue';

    export default {
        components: { 'icon-close': IconClose },

        data() {
            return { INTERFACE_PANEL_TRIGGERS: INTERFACE_PANEL_TRIGGERS };
        },
        computed: {
            ...mapState(['uiElements']),
            ...mapGetters([
                'getUserName',
                'getWebTheme',
                'getWebThemeParameters',
                'getDetailInformationPanelHeight'
            ]),
            menuPanel: function () {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.MENU];
            },
            menuComponents: function () {
                return this.menuPanel.components;
            },
            webTheme() {
                return this.getWebTheme?.data;
            },
            showLegendMenuOption: function () {
                return this.menuComponents.legend.visible;
            },
            showFilterMenuOption: function () {
                return this.menuComponents.filter.visible;
            },
            showMeasureMenuOption: function () {
                return this.menuComponents.measure.visible;
            },
            showPrintMenuOption: function () {
                return this.menuComponents.print.visible;
            },
            showAccessibilityMenuOption: function () {
                return this.menuComponents.accessibility.visible;
            },
            showWelcomeMessageOption: function() {
                return this.menuComponents.welcome.visible;
            },
            /**
             * Return the class for menu panel
             * @returns {string} - style
             */
            getObjectDetailClass() {
                return {
                    show: this.menuPanel.visible,
                    baselayer: this.$store.getters.getBaseLayers.length > 0
                };
            },
            $_getStyle() {
                const resize = this.menuPanel.resize;
                return resize
                    ? `max-height: calc(100% - ${MENUBAR_HEIGHT}px - ${this.getDetailInformationPanelHeight}px - 10px)`
                    : null;
            }
        },
        methods: {
            ...mapActions(['togglePanel']),
            $_click_welcome_panel() {
                const data =
                {
                    title: this.webTheme?.welcomeMessageTitle,
                    message: this.webTheme?.welcomeMessage
                };
                this.togglePanel({
                    panelName: INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL, visible: true, data
                });
            }
        }
    };
</script>

<style scoped lang="scss">
.menucontainer {
    flex: 1;
    display: flex !important;
    flex-direction: column;
    padding: 10px 0px 10px 0px;
}

.menu-detail {
    @include z-index(menu-panel);
    position: absolute;
    top: $menu-bar-height;
    right: 100%;
    left: -470px;
    width: 300px;
    background-color: #fff;
    overflow-x: hidden;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    display: flex !important;
    flex-direction: column;
    max-height: calc(100% - $menu-bar-height);

    &.show {
        @include margin-left-navbar;
        position: absolute;
        top: $menu-bar-height;
    }

    &.baselayer {
        max-height: calc(100% - 155px);
    }
}
.menu-span-adjustment {
    font-size: large;
}
.menu-link {
    color: $gray-07;
    &:hover {
        text-decoration: none;
    }
}
.sidebar-item {
    padding: 10px 3px 10px 18px;
    display: flex;
}

.sidebar-item em {
    margin-right: 18px;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat !important;
    background-size: 20px;
}

/*-------------------------------------
    max-width : 480px
    ---------------------------------------*/
@media (max-width: 480px) {
    .menu-detail.show {
        width: calc(100% - 20px);

        .large-navbar & {
            width: 100%;
        }
    }
}
</style>
